import { signal } from "@preact/signals-react";

const laudar = signal(false);

export default laudar;